module.exports = __webpack_public_path__ + "static/media/comparison.29363855.svg";